// https://stackoverflow.com/a/72728396/8062659
export async function resizeImage(file: File, dimensions: { width: number; height: number }) {
  if (!file.type.match(/image.*/)) {
    throw new Error('File must be a type of image.');
  }

  const image = new Image();
  image.src = URL.createObjectURL(file);

  await new Promise<Event>((resolve) => (image.onload = resolve));

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d', { alpha: true });

  if (context === null) {
    throw new Error('Canvas `getContext` method resulted to null.');
  }

  canvas.width = dimensions.width;
  canvas.height = dimensions.height;

  if (image.height <= image.width) {
    const scaleProportions = canvas.height / image.height;
    const scaledWidth = scaleProportions * image.width;
    context.drawImage(image, (canvas.width - scaledWidth) / 2, 0, scaledWidth, canvas.height);
  } else {
    const scaleProportions = canvas.width / image.width;
    const scaledHeight = scaleProportions * image.height;
    context.drawImage(image, 0, (canvas.height - scaledHeight) / 2, canvas.width, scaledHeight);
  }

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((result) => {
      if (result === null) {
        reject(new Error('Canvas `toBlob` method resulted to null.'));
      } else {
        resolve(result);
      }
    });
  });
}

export function blobToBase64(blob: Blob) {
  const reader = new FileReader();
  reader.readAsDataURL(blob);

  return new Promise<string>((resolve) => {
    reader.onloadend = () => {
      resolve(String(reader.result));
    };
  });
}

export function getBase64MbSize(base64: string) {
  const y = base64.endsWith('==') ? 2 : 1;
  const x = base64.length * (3 / 4) - y;
  return bytesToMegaBytes(Math.round(x / 1024));
}

function bytesToMegaBytes(bytes: number) {
  return bytes / (1024 * 1024);
}
